import { render, staticRenderFns } from "./CatTable.vue?vue&type=template&id=c85df96a&scoped=true&"
import script from "./CatTable.vue?vue&type=script&lang=js&"
export * from "./CatTable.vue?vue&type=script&lang=js&"
import style0 from "./CatTable.vue?vue&type=style&index=0&id=c85df96a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85df96a",
  null
  
)

export default component.exports